import { computed, ref, watch } from "vue";
import { whenI18nReady } from "#ce/components/SpFinder/i18n";
import { useFinderMap } from "#ce/apps/SpFinderMap/composables/useFinderMap";

/**
 * Returns the finder map inputs plus which surface renders. Each waits for the finder strings:
 *   - rendering:        the desktop map, for a map view with results and settings
 *   - mobileRendering:  the small-screen dialog, for a selected result
 * Crossing the small-screen breakpoint clears the map selection.
 */
export function useFinderMapApp() {
  const ready = ref(false);
  function markReady() {
    ready.value = true;
  }
  whenI18nReady.then(markReady);
  const map = useFinderMap();
  const { desktop, payload, settings, mobile, selected, selection, commands } = map;
  function breakpointChanged(value, previous) {
    if (value !== previous && selection.value?.resultGUID) {
      commands.clearMapSelection();
    }
  }
  watch(mobile, breakpointChanged);
  return {
    ...map,
    rendering: computed(() => ready.value && desktop.value && payload.value && settings.value),
    mobileRendering: computed(() => ready.value && mobile.value && selected.value && settings.value),
  };
}
